export default __webpack_public_path__ + "static/generator_w.5b207875ca23027256c1f18a312f3aa3.svg";